import { CustomSelectionType } from './CustomSelectionType';

export type RecurrencePickerRouteNames =
  | 'start'
  | 'dailyRecurrence'
  | 'selectDailyInterval'
  | 'selectEndDate'
  | 'selectCount'
  | 'weeklyRecurrence'
  | 'selectWeeklyInterval'
  | 'monthlyRecurrence'
  | 'selectMonthlyInterval'
  | 'yearlyRecurrence'
  | 'selectYearlyInterval';

export class RecurrencePickerRoutes {
  readonly dailyRecurrence: RecurrencePickerRouteNames = 'dailyRecurrence';
  readonly weeklyRecurrence: RecurrencePickerRouteNames = 'weeklyRecurrence';
  readonly monthlyRecurrence: RecurrencePickerRouteNames = 'monthlyRecurrence';
  readonly yearlyRecurrence: RecurrencePickerRouteNames = 'yearlyRecurrence';

  routeToSelectionType(route: RecurrencePickerRouteNames): CustomSelectionType {
    switch (route) {
      case this.dailyRecurrence:
        return CustomSelectionType.DAILY;
      case this.weeklyRecurrence:
        return CustomSelectionType.WEEKLY;
      case this.monthlyRecurrence:
        return CustomSelectionType.MONTHLY;
      case this.yearlyRecurrence:
        return CustomSelectionType.YEARLY;
    }

    return CustomSelectionType.DAILY;
  }

  selectionTypeToRoute(selectionType: CustomSelectionType): RecurrencePickerRouteNames {
    switch (selectionType) {
      case CustomSelectionType.DAILY:
        return this.dailyRecurrence;
      case CustomSelectionType.WEEKLY:
        return this.weeklyRecurrence;
      case CustomSelectionType.MONTHLY:
        return this.monthlyRecurrence;
      case CustomSelectionType.YEARLY:
        return this.yearlyRecurrence;
    }
  }
}
